import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';

import PrivateIcon from 'assets/images/offer/private-type.svg?react';
import PublicIcon from 'assets/images/offer/public-type.svg?react';

import styles from './OfferType.module.scss';

interface IOfferTypesProps extends HTMLAttributes<HTMLDivElement> {
	isPublic?: boolean;
}

export const OfferType: FC<IOfferTypesProps> = ({ isPublic }) => {
	const { t } = useTranslation();

	return (
		<Flex gap={4} align='center'>
			{isPublic ? (
				<PublicIcon width={18} height={18} className={styles.public} />
			) : (
				<PrivateIcon width={18} height={18} className={styles.private} />
			)}
			<Typography.Text className={isPublic ? styles.public : styles.private}>
				{isPublic ? t('Public offer') : t('Private offer')}
			</Typography.Text>
		</Flex>
	);
};
